import React from 'react'

type Props = {
    className?: string
}

export const ClockIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="M12 6v6l4 2"/>
            <circle cx="12" cy="12" r="10"/>
        </svg>
    )
}
